/**
 * Symplifi   API
 * Symplifi backend API description 
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FileDto } from './file-dto';
import { CreditInformationDto } from './credit-information-dto';
import { UserDto } from './user-dto';
import { PricingPlanDto } from './pricing-plan-dto';


export interface CompanyDtoWithFiles { 
    id: string;
    name?: string | null;
    country: CompanyDtoWithFiles.CountryEnum;
    type: CompanyDtoWithFiles.TypeEnum;
    address?: string | null;
    kycStatus?: CompanyDtoWithFiles.KycStatusEnum;
    registrationNumber?: string | null;
    vatNumber?: string | null;
    websiteUrl?: string | null;
    yearsInBusiness?: number | null;
    employeeCount?: number | null;
    customerCount?: number | null;
    estimatedMonthlyRevenue?: number | null;
    creditInformation?: CreditInformationDto | null;
    feePercentage?: number | null;
    pricingPlan?: PricingPlanDto | null;
    subscriptionDate?: string | null;
    trialExpiresAt?: string;
    files: Array<FileDto>;
    users: Array<UserDto>;
}
export namespace CompanyDtoWithFiles {
    export type CountryEnum = 'Rwanda' | 'Kenya';
    export const CountryEnum = {
        Rwanda: 'Rwanda' as CountryEnum,
        Kenya: 'Kenya' as CountryEnum
    };
    export type TypeEnum = 'Business' | 'Individual' | 'NotSpecified';
    export const TypeEnum = {
        Business: 'Business' as TypeEnum,
        Individual: 'Individual' as TypeEnum,
        NotSpecified: 'NotSpecified' as TypeEnum
    };
    export type KycStatusEnum = 'NOT_SUBMITTED' | 'PENDING' | 'APPROVED' | 'DECLINED';
    export const KycStatusEnum = {
        NotSubmitted: 'NOT_SUBMITTED' as KycStatusEnum,
        Pending: 'PENDING' as KycStatusEnum,
        Approved: 'APPROVED' as KycStatusEnum,
        Declined: 'DECLINED' as KycStatusEnum
    };
}


